import { useEffect, useState } from 'react';
import { atom, useRecoilValue, useSetRecoilState } from 'recoil';
const timeState = atom({
    key: 'timeState',
    default: undefined,
});
export function useClockEffect() {
    const setTime = useSetRecoilState(timeState);
    useEffect(() => {
        setTime(Date.now());
        const intervalId = window.setInterval(() => {
            setTime(Date.now());
        }, 1000);
        return () => {
            window.clearInterval(intervalId);
        };
    }, [setTime]);
}
export function useTime() {
    const [time] = useState(() => Date.now());
    return useRecoilValue(timeState) ?? time;
}
export function useThrottledTime(intervalInMillis = 5000) {
    const time = useTime();
    const [throttledTime, setThrottledTime] = useState(time);
    useEffect(() => {
        if (time - throttledTime >= intervalInMillis) {
            setThrottledTime(time);
        }
    }, [time, intervalInMillis, throttledTime]);
    return throttledTime;
}
